export const TEAM_COLORS = [
  { key: "laranja", label: "Laranja", bg: "#FF8C00", text: "#000" },
  { key: "vermelho", label: "Vermelho", bg: "#E10600", text: "#fff" },
  { key: "amarelo", label: "Amarelo", bg: "#FFD400", text: "#000" },
  { key: "rosa", label: "Rosa", bg: "#FF69B4", text: "#000" },
  { key: "azul", label: "Azul", bg: "#0057FF", text: "#fff" },
  { key: "verde", label: "Verde", bg: "#00A651", text: "#fff" },
  { key: "preto", label: "Preto", bg: "#000000", text: "#fff" },
  { key: "branco", label: "Branco", bg: "#FFFFFF", text: "#000" },
  { key: "castanho", label: "Castanho", bg: "#7B4A2A", text: "#fff" },
];

const DEFAULT = { bg: "#1a1a1a", text: "#fff" };

export const teamColor = (team) => TEAM_COLORS.find((c) => c.key === team?.color) || DEFAULT;

export const teamStyle = (team) => {
  const c = teamColor(team);
  return { background: c.bg, color: c.text };
};
